import style from './FormContainer.module.css';

import { IoCloseOutline } from "react-icons/io5";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import SmallLoading from '../Utils/SmallLoading';

const FormContainer = ({ closeFunc, children, changeContent, loadingSave, loadingContent }) => {

    const clickClose = () => {

        closeFunc(false)

        if (changeContent) {

            changeContent();

        }

    }

    return (
        <div className={style.formContainer} onClick={(e) => { e.stopPropagation() }} >
            <div className={style.headerContainer} >
                {<IoCloseOutline onClick={() => { clickClose() }} />}
            </div>

            {
                loadingContent
                    ? <SmallLoading />
                    : <div className={style.bodyContainer} >
                        {children}
                    </div>
            }

            <div className={loadingSave ? style.saveChanges : style.waitChanges} >

                <AiOutlineLoading3Quarters size={40} />

            </div>

        </div>
    )

}

export default FormContainer;